import Q19 from './Q19';

export default Q19;
